module.exports = __webpack_public_path__ + "roundabout_right.svg?a6528d4784a130e8abe5d0cea1c27471";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_right.svg
// module id = 217
// module chunks = 0